import { render } from "./LandlordDashboard.vue?vue&type=template&id=1ebb50e2&scoped=true"
import script from "./LandlordDashboard.vue?vue&type=script&lang=js"
export * from "./LandlordDashboard.vue?vue&type=script&lang=js"

import "./LandlordDashboard.vue?vue&type=style&index=0&id=1ebb50e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebb50e2"]])

export default __exports__